// Create "window.Shoppad.apps.infiniteoptions" object if it doesn't already exist
'Shoppad.apps.infiniteoptions'.split('.').reduce(function (o, x) {
  if (!o[x]) {
    o[x] = {};
  }
  return o[x];
}, window);

// Define beforeReadyInternal callback
window.Shoppad.apps.infiniteoptions.beforeReadyInternal = function (subscribe) {

  /**
   * Get parsed price object from target node
   *
   * @param {string} targetNode
   */
  let getParsedPrice = function (targetNode) {
    let parsedPrice = {
      priceElement: '',
      originalProductPrice: '',
      productPrice: '',
      productPricePrefix: '',
      productPriceSuffix: '',
    };

    parsedPrice['priceElement'] = document.querySelector(targetNode);
    parsedPrice['originalProductPrice'] = parsedPrice.priceElement.textContent;
    parsedPrice['productPrice'] = Number(
      parsedPrice.originalProductPrice.replace(/[^0-9\.-]+/g, '')
    ).toFixed(2);
    parsedPrice['productPricePrefix'] = parsedPrice.originalProductPrice.substr(
      0,
      parsedPrice.originalProductPrice.search(/\d/)
    );
    parsedPrice[
      'productPriceSuffix'
    ] = parsedPrice.originalProductPrice
      .replace(',', '')
      .replace(parsedPrice.productPrice, '')
      .replace(parsedPrice.productPricePrefix, '')
      .replace(/[^A-Za-z\\\s]+/g, '');

    return parsedPrice;
  };

  /**
   * Watch for price change from third parties
   */
  let constructObserver = function () {
    if (observerSet) {
      return;
    }

    observerSet = true;

    let targetNode = document.querySelector('.infiniteoptions-price .price-item--regular');

    // Options for the observer
    let config = { characterData: true, childList: true, subtree: true };

    // Callback function to execute when mutations are observed
    const callback = function (mutationsList) {
      for (const mutation of mutationsList) {
        let nodeAdded =
          mutation.addedNodes &&
          mutation.addedNodes.length &&
          mutation.addedNodes[0].nodeValue;

        // Check if mutation warrants a reaction
        if (
          nodeAdded &&
          mutation.type === 'childList' &&
          bundledProducts
        ) {
          // Store existing, get new price
          let existingPrice = price.productPrice;
          price = getParsedPrice('.infiniteoptions-price .price-item--regular');

          // Exit if existing price matches updated price
          if (existingPrice === price.productPrice) {
            return;
          }

          // Update product price
          price.productPrice = (
            Number(price.productPrice) + Number(bundledPrice)
          ).toFixed(2);
          price.priceElement.textContent =
            price.productPricePrefix +
            price.productPrice +
            price.productPriceSuffix;
        }
      }
    };

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);

    // Start observing the target node for configured mutations
    observer.observe(targetNode, config);
  };

  /**
   * Public helper method gets the latest product variant price by fetching the Shopify product via $.ajax
   * @param {object} productBundle
   * @param {function} callback
   */
  function getLatestVariantPrice(productBundle, callback) {
    if (typeof productBundle.shopifyPriceSynced === 'undefined') {
      window.Shoppad.$.ajax({
        url: "/products/" + productBundle.handle + ".json",
        success: function (response) {

          if (
            response && 
            response.product && 
            response.product.id
          ) {
            for (let i = 0; i < response.product.variants.length; i++) {
              if (
                response.product.variants[i].id == productBundle.variantId
              ) {
                productBundle.price = response.product.variants[i].price;
              }
            }
          }
          return callback(productBundle);
        },
        error: function (result) {
          return callback(productBundle);
        },
      });
    } else {
      return callback(productBundle);
    }
  };

  /**
   * Format product price with comma separators in the thousands place
   *
   * @param {string} price
   */
  let formatPriceWithCommaSeparator = function (price) {    
    let numberPrice = Number(price);

    if (isNaN(numberPrice)) {
      return price;
    }

    let numberPriceLocale = numberPrice.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2});
    return numberPriceLocale;
  };

  // Target price element
  let targetNode = '.infiniteoptions-price .price-item--regular';
  // Flag to determine if the observer has been set or not
  let observerSet = false;
  // Store count of bundled products
  let bundledProducts = 0;
  // Store total price of all bundled products
  let bundledPrice = '0.00';
  // Price object
  let price = getParsedPrice(targetNode);

  /**
   * Watch for URL path change when variant selection changes
   */
  let currentPath = window.location.href;
  setInterval(function() {
    if (window.location.href !== currentPath) {
      currentPath = window.location.href;
      onUrlChange();
    }
  }, 50);

  /**
   * Handle variant pricing updates when variant selection changes
   */
  function onUrlChange() {
    let variantUrl = location.href;
    // Use regex capturing group to narrow down variantID from URL
    const matches = variantUrl.match(/variant\=(\d+)/);
    if (!matches || !matches[1]) {
      // No variant in query params
      return;
    }
    // Set the variantId to the proper match (40173598834777)
    const variantId = matches[1];

    // Use variant ID from URL and get the variant price by fetching the Shopify variant via $.ajax
    window.Shoppad.$.ajax({
      url: "/variants/" + variantId + ".json",
      success: function (response) {
        // Update product price
        price.productPrice = (
          Number(response.product_variant.price) + Number(bundledPrice)
        ).toFixed(2);
        // Update display of product price
        document.querySelector(targetNode).textContent =
          price.productPricePrefix + formatPriceWithCommaSeparator(price.productPrice) + price.productPriceSuffix;
      },
      error: function (error) {
        console.log(`Error ${error}`);
      }
    })
  }
  
  /**
   * Handle product bundle add
   */
  subscribe('productBundleAdd', function (event) {
    // Set up observer
    constructObserver();
    
    // Update product bundle data
    bundledProducts = bundledProducts + 1;
  
    // Get the latest price (in case it has changed since the optionset was created) and update the price on the DOM
    getLatestVariantPrice(event.detail.productBundle, function(productBundle) { 
      bundledPrice = (
        Number(bundledPrice) + Number(productBundle.price)
      ).toFixed(2);

      // Update product price
      price.productPrice = (
        Number(price.productPrice) + Number(productBundle.price)
      ).toFixed(2);
      // Update display of product price
      document.querySelector(targetNode).textContent =
        price.productPricePrefix + formatPriceWithCommaSeparator(price.productPrice) + price.productPriceSuffix;
    });     
  });

  /**
   * Handle product bundle remove
   */
  subscribe('productBundleRemove', function (event) {
    // Update product bundle data
    bundledProducts = bundledProducts - 1;
    
    // Get the latest price (in case it has changed since the optionset was created) and update the price on the DOM
    getLatestVariantPrice(event.detail.productBundle, function(productBundle) {
      bundledPrice = (
        Number(bundledPrice) - Number(event.detail.productBundle.price)
      ).toFixed(2);

      // Update product price
      price.productPrice = (
        Number(price.productPrice) - Number(event.detail.productBundle.price)
      ).toFixed(2);
      // Update display of product price
      document.querySelector(targetNode).textContent =
        price.productPricePrefix + formatPriceWithCommaSeparator(price.productPrice) + price.productPriceSuffix;
    });
  });

};